import { Link } from "@remix-run/react"
import Autoplay from "embla-carousel-autoplay"
import { CardProduct } from "~/types"
import { getBackgroundStyle } from "~/utils/utils"
import { Carousel, CarouselContent, CarouselItem } from "../ui/carousel"
import NewArrivalBigProductCard from "./NewArrivalBigProductCard"

// =============================================================
type Props = {
  products: any[]
  logo: string
  description: string
  link: string
  bgColor: string
}
// =============================================================

export default function NewArrivalBigCard({
  products,
  logo,
  description,
  link,
  bgColor,
}: Props) {
  return (
    <div
      className="relative flex flex-col h-full rounded-[50px] p-4 md:p-8"
      style={getBackgroundStyle(bgColor)}
    >
      <div>
        <img src={logo} alt="brandlogo" className="h-24" />
      </div>
      <div className="text-white">{description}</div>
      {/* Product Carousel */}
      <div className="relative z-10 mt-4">
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          plugins={[Autoplay({ delay: 8000 })]}
          className="[&>div]:px-1 w-full"
        >
          <CarouselContent className="-ml-3 py-2 flex">
            {products.map((item: any, index) => (
              <CarouselItem
                key={index}
                className="pl-3 flex basis-1/2 items-stretch"
              >
                <NewArrivalBigProductCard
                  item={
                    {
                      id: item?.id,
                      name: item?.productName,
                      defaultVariantId: item?.productVariantId,
                      priceWithTax: item?.regularPrice,
                      shortDescription: item?.description,
                      slug: item?.sku,
                      image: item?.assets?.[0] ?? "",
                      inStock: item?.stockOnHand > 0,
                      assets: item?.assets ?? [],
                      discountPercent: item?.discountPercent ?? 0,
                      computedPrice: item?.computedPrice ?? 0,
                      giftProducts: item?.hasGiftProducts,
                      productType: item?.variantType,
                      discountEndDate: item?.discountEndDate,
                      wholesalePrice: item?.wholesalePrice,
                      wholesaleMoq: item?.wholesaleMoq,
                      stockOnHand: item?.stockOnHand,
                      facetValueIds: item?.facetValueIds ?? [],
                    } as CardProduct
                  }
                />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
      <div className="mt-7 md:mt-12 relative z-20 w-1/2">
        <Link
          to={link}
          reloadDocument
          className="bg-white/10 text-white px-4 py-3 rounded-2xl inline-block w-full text-center"
        >
          Дэлгэрэнгүй
        </Link>
      </div>
    </div>
  )
}
